/* @flow */

import { type Ingredient, Pizza } from './pizza';

export type DiagnoseResult = {
  like: Array<Ingredient>,
  dislike: Array<Ingredient>,
};

export type DetailResult = Array<[Ingredient, number]>;

// O(m*n), but ok for small input
export const mergeDetailResult = (a: DetailResult, b: DetailResult): DetailResult => {
  const result = a.map(([i, s]) => [i, s]); // clone a

  for (const [ingredient, score] of b) {
    const ingredientScorePair = result.find(([i, _]) => i === ingredient);
    if (ingredientScorePair) {
      ingredientScorePair[1] = ingredientScorePair[1] + score;
    } else {
      result.push([ingredient, score]);
    }
  }

  return result;
};

export interface Order {
  toString(): string;
  fitScore(pizza: Pizza): number;
  fitScoreDetail(pizza: Pizza): DetailResult;
}
